import { labelToDataId } from "@flexidao/ui-lib/utils";
import { Divider, Stack } from "@mantine/core";
import { ReactElement, ReactNode } from "react";

export type SectionContentProps = {
    hasDivider?: boolean;
    noSpaceAfterDivider?: boolean;
    children: ReactNode;
    dataId: string;
};

const SPACING_AFTER_DIVIDER = 8;

export const SectionContent = ({
    dataId,
    hasDivider = false,
    noSpaceAfterDivider = true,
    children,
}: SectionContentProps): ReactElement => {
    const spacingAfterDivider = noSpaceAfterDivider ? 0 : SPACING_AFTER_DIVIDER;
    return (
        <Stack spacing={spacingAfterDivider}>
            {hasDivider && (
                <Divider data-id={labelToDataId({ prefix: dataId, label: "divider" })} />
            )}
            <div
                data-id={labelToDataId({ prefix: dataId, label: "body" })}
                style={{
                    position: "unset",
                    width: "100%",
                    height: "100%",
                }}
            >
                {children}
            </div>
        </Stack>
    );
};
